import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select one", -1)
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.input.divClass)
  }, [
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.value) = $event)),
      class: "form-control"
    }, [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.input.options as any[]), (op) => {
        return (_openBlock(), _createElementBlock("option", {
          key: op,
          value: op.value
        }, _toDisplayString(op.option), 9, _hoisted_2))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.input.value]
    ])
  ], 2))
}